<template>
    <btn
        :loading="loading"
        :disabled="loading"
        @click.native="performAction()"
    ><slot></slot></btn>
</template>

<script>
export default {
    props: {
        action: {
            type: String,
            required: true
        },
        notify: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            loading: false
        }
    },

    methods: {
        performAction() {

            this.loading = true;

            axios.patch(this.action)
                .then(response => {
                    this.loading = false;
                    if (this.notify) {
                        Notify.info(this.notify);
                    }
                })
                .catch(error => {
                    this.loading = false;
                    Notify.error('error');
                });
        },
    }
}
</script>
